import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import UrzadRaportDoplatGrupTable from "./components/UrzadRaportDoplatGrupTable";
import UrzadRaportDopatGrupSearchbox from "./components/UrzadRaportDopatGrupSearchbox";
import UrzadService from "../UrzadService";
import UrzadRaportDoplatGrupOgolemTable from "./components/UrzadRaportDoplatGrupOgolemTable";

export default class UrzadRaportDoplatGrup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            raportgrupa1: [],
            raportgrupa2: [],
            raportgrupa3: [],
            wszystkie: [],
            czyByloSzukanie: false,
            setLoader: false,
        };
    }

    componentDidMount() {
    }


    przeFiltrujIPodsumuj(originalArray, grupa) {
        let arr = Array.from(originalArray.filter(item => item.nrgrupy === grupa))

        let p_ilosc = 0;
        let p_wartbilbrutto = 0;
        let p_wartbilnetto = 0;
        let p_wartbilvat = 0;
        let p_wartdoplbrutto = 0;
        let p_wartdoplnetto = 0;
        let p_wartdoplvat = 0;

        for (let i = 0; i < arr.length; i++) {
            let item = arr[i];

            if (item.status === "PRAWIDŁOWE") {
                 p_ilosc += item.ilosc;
                 p_wartbilbrutto += item.wartbilbrutto;
                 p_wartbilnetto += item.wartbilnetto;
                 p_wartbilvat += item.wartbilvat;
                 p_wartdoplbrutto += item.wartdoplbrutto;
                 p_wartdoplnetto += item.wartdoplnetto;
                 p_wartdoplvat += item.wartdoplvat;
            }
        }

        arr.push(
            {
                "nazwaulgi": "PODSUMOWANIE DLA PRAWIDŁOWYCH",
                "proculgi": "",
                "status": "",
                "wartdoplbrutto": p_wartdoplbrutto,
                "wartdoplnetto": p_wartdoplnetto,
                "wartdoplvat": p_wartdoplvat,
                "ilosc": p_ilosc,
                "wartbilbrutto": p_wartbilbrutto,
                "wartbilnetto": p_wartbilnetto,
                "wartbilvat": p_wartbilvat,
                "nrgrupy": grupa
            }
        );

        return arr;
    }


    podsumowanieDlaWszystkich(array){

        let arr = Array.from(array)

        let p_ilosc = 0;
        let p_wartbilbrutto = 0;
        let p_wartbilnetto = 0;
        let p_wartbilvat = 0;
        let p_wartdoplbrutto = 0;
        let p_wartdoplnetto = 0;
        let p_wartdoplvat = 0;

        for (let i = 0; i < arr.length; i++) {
            let item = arr[i];

            if (item.status === "PRAWIDŁOWE") {
                p_ilosc += item.ilosc;
                p_wartbilbrutto += item.wartbilbrutto;
                p_wartbilnetto += item.wartbilnetto;
                p_wartbilvat += item.wartbilvat;
                p_wartdoplbrutto += item.wartdoplbrutto;
                p_wartdoplnetto += item.wartdoplnetto;
                p_wartdoplvat += item.wartdoplvat;
            }
        }

        let all = [{
            "nazwaulgi": "PODSUMOWANIE DLA WSZYSTKICH PRAWIDŁOWYCH",
            "proculgi": "",
            "status": "",
            "wartdoplbrutto": p_wartdoplbrutto,
            "wartdoplnetto": p_wartdoplnetto,
            "wartdoplvat": p_wartdoplvat,
            "ilosc": p_ilosc,
            "wartbilbrutto": p_wartbilbrutto,
            "wartbilnetto": p_wartbilnetto,
            "wartbilvat": p_wartbilvat,
            "nrgrupy": "wszystkie"
        }]

        return all
    }

    onClickSzukaj(dataOd, dataDo) {
        this.setState({czyByloSzukanie: true, setLoader: true})
        UrzadService.getpUrzadDoplatyDoGrupUlg(dataOd, dataDo).then(function (response) {
            console.log(response)

            this.setState({
                wszystkie: this.podsumowanieDlaWszystkich(response.data),
                raportgrupa1: this.przeFiltrujIPodsumuj(response.data,1),
                raportgrupa2: this.przeFiltrujIPodsumuj(response.data,2),
                raportgrupa3: this.przeFiltrujIPodsumuj(response.data,3),
                setLoader: false
            })

            /*this.setState({
                raport: Array.from(response.data, item => {
                    return {
                        odcinek: item.naz_pr_od + ' - ' + item.naz_pr_do,
                        ...item
                    }
                }), setLoader: false
            })*/
        }.bind(this))
    }


    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'UrzadContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/urzad', text: 'Urząd'}, {
                                        addressUrl: '/urzad/raport-doplat-grup',
                                        text: 'Raport dopłat do grup'
                                    }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <UrzadRaportDopatGrupSearchbox handleClickSzukaj={(dataOd, dataDo) => this.onClickSzukaj(dataOd, dataDo)}/>
                        </Col>
                        <Col sm={12}>
                            {
                                Boolean(this.state.czyByloSzukanie) ?
                                    Boolean(this.state.setLoader) ?
                                        <div id={'simple-small-loader'}>
                                            <i className={'fa fa-spinner fa-spin'}></i>
                                        </div>
                                        :
                                        <div>
                                            <UrzadRaportDoplatGrupTable data={this.state.raportgrupa1} grupa={1}/>
                                            <UrzadRaportDoplatGrupTable data={this.state.raportgrupa2} grupa={2}/>
                                            <UrzadRaportDoplatGrupTable data={this.state.raportgrupa3} grupa={3}/>
                                            <UrzadRaportDoplatGrupOgolemTable data={this.state.wszystkie} />
                                        </div>
                                    :
                                    ''
                            }
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/RaportDoplatGrup/UrzadRaportDoplatGrup.js